"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OutletController_js_1 = require("./OutletController.js");
exports.OutletController = OutletController_js_1.OutletController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/outlet/controllers/index.ts
// module id = 378
// module chunks = 0